import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
`;

interface Props {
  className?: string;
}

export const BudgetIcon: React.FC<Props> = ({ className }) => {
  return (
    <StyledRoot
      className={className}
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" />
    </StyledRoot>
  );
};
